
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Switch from "react-switch";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Resizer from "react-image-file-resizer";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,
            modal_add: false,

            loading: false,
            data_category: [],
            data_product: [],
            data_unit: [
                { value: "ชุด", label: "ชุด" },
                { value: "อัน", label: "อัน" },
                { value: "ชิ้น", label: "ชิ้น" },
                { value: "เครื่อง", label: "เครื่อง" },
            ],

            tab: 1,

            code_category: "",
            picture: "",
            product_id: "",
            product_code: "",
            product_name: this.props.location.query.name ?? "",
            category_id: "",
            serial_number: false,
            product_type: this.props.location.query.type,
            sell_price: 0,
            cost_price: 0,
            product_detail: "",
            unit_name: ""
        }
    }
    async componentDidMount() {
        await this.geCategoryAll();
        await this.getProductAll();
        if (this.props.location.query.id) {
            await this.Get(this.props.location.query.id);
        }
    }
    Get = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            product_id: id
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("Get:", result);
            this.setState({
                picture: result.data.picture,
                product_id: result.data.product_id,
                product_code: result.data.product_code,
                product_name: result.data.product_name,
                category_id: this.state.data_category.filter(e => e.value === result.data.category_id)[0],
                code_category: this.state.data_category.filter(e => e.value === result.data.category_id)[0].code,
                product_type: result.data.product_type,
                serial_number: result.data.have_serial,
                sell_price: result.data.sell_price,
                cost_price: result.data.cost_price,
                product_detail: result.data.product_detail,
                unit_name: result.data.unit_name ? { value: result.data.unit_name, label: result.data.unit_name } : "",
            });
        }
        this.setState({ loading: false });
    }
    geCategoryAll = async () => {
        let body = {
            page: 0,
            data_search: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product-category/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_category: result.data.map(e => { return { value: e.category_id, label: e.category_name, code: e.category_code } }) });
        }
    }
    getProductAll = async () => {
        let body = {
            page: 0,
            data_search: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product-category/list", body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_category: result.data.map(e => { return { value: e.category_id, label: e.category_name, code: e.category_code } }) });
        }
    }
    CreateProduct = async () => {
        // if (validate(this.state, ["branch_number", "branch_name", "address_detail", "address_id", "post_code", "phone_number", "tax_number",])) { return };
        this.setState({ loading: true });
        let data = {
            category_id: this.state.category_id ? this.state.category_id.value : "",
            picture: this.state.picture,
            product_code: this.state.product_code,
            product_name: this.state.product_name,
            product_type: this.state.product_type,
            have_serial: this.state.serial_number,
            sell_price: Number(this.state.sell_price),
            cost_price: Number(this.state.cost_price),
            product_detail: this.state.product_detail,
            unit_name: this.state.unit_name ? this.state.unit_name.value : "",
            type: this.state.type
        }
        let result = await POST(tokens, "v1/TH/product-manage/product/create/" + getStorage("branch").branch_id, data);
        if (result && result.status) {
            success_url("/master/list-spare-parts-repair");
        }
        this.setState({ loading: false });
    }
    UpdateProduct = async () => {
        this.setState({ loading: true });
        let data = {
            product_id: this.state.product_id,
            category_id: this.state.category_id ? this.state.category_id.value : "",
            picture: this.state.picture,
            product_code: this.state.product_code,
            product_name: this.state.product_name,
            product_type: this.state.product_type,
            have_serial: this.state.serial_number,
            sell_price: Number(this.state.sell_price),
            cost_price: Number(this.state.cost_price),
            product_detail: this.state.product_detail,
            unit_name: this.state.unit_name ? this.state.unit_name.value : "",
            type: this.state.type
        }
        let result = await PUT(tokens, "v1/TH/product-manage/product/update", data);
        if (result && result.status) {
            success_url("/master/list-spare-parts-repair");
        }
        this.setState({ loading: false });
    }
    import_file = (e) => {
        this.changePhoto(e.target.files[0])
        document.getElementById("file").value = "";
        document.getElementById("file").file = null;
    }
    changePhoto = async (file) => {
         
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    this.setState({ picture: uri.split(",")[1] })
                },
                "base64"
            );
        });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    {this.state.product_type === "อะไหล่" && (
                        <div className="row">
                            <div className="col-12 col-md-8 col-lg-6 mx-auto p-3">
                                {/* หัวข้อ และ ปุ่มเพิ่ม */}
                                <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                                    <h3 className="mb-2"><b>{this.state.product_id ? "แก้ไขอะไหล่" : "เพิ่มอะไหล่"}</b></h3>
                                    <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master/list-spare-parts-repair" }}>
                                        <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                    </button>
                                </div>
                                <div className="w-100 card border-0 p-3 rounded-lg">
                                    <div className="row">
                                        {/* รูปสาขา */}
                                        <div className="col-12 mb-2">
                                            <label className="mb-2">ภาพสินค้า:</label>
                                            {this.state.picture === "" ? (
                                                <div
                                                    className="w-100 pointer card d-flex align-items-center justify-content-center px-3 py-5 bg-light rounded hpx-200"
                                                    onClick={() => { document.getElementById("file").click() }}
                                                >
                                                    <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                                    <label className="text-secondary pointer">อัปโหลดรูปภาพ</label>
                                                </div>
                                            ) : (
                                                <div className="w-100 card border-2 border-orange d-flex align-items-center justify-content-center p-2  mb-2">
                                                    <div className="position-relative w-100">
                                                        <img alt="ภาพสินค้า" src={this.state.picture.includes("https://") ? this.state.picture : "data:image/png;base64," + this.state.picture} className="w-100 rounded overflow-hidden"></img>
                                                        <div className="icon pointer bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ picture: "" }) }}>
                                                            {"\uf00d"}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <input className="d-none" type="file" id="file" accept="image/*" onChange={(e) => { this.import_file(e, "main") }} />
                                        </div>
                                        <div className="col-6 mb-2">
                                            <label className="mb-2">รหัสสินค้า:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ product_code: e.target.value }) }}
                                                value={this.state.product_code}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-6 mb-2">
                                            <label className="mb-2">ชื่อสินค้า:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ product_name: e.target.value }) }}
                                                value={this.state.product_name}
                                            />
                                        </div>
                                        <div className="col-6 mb-2">
                                            <label className="mb-2">ประเภท:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                value={this.state.product_type}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-6 mb-2">
                                            <label className="mb-2">หมวดหมู่:</label>
                                            <Select
                                                className="form-control select-search "
                                                styles={select_style}
                                                options={this.state.data_category}
                                                onChange={(e) => {
                                                    console.log(e);
                                                    this.setState({ 
                                                        category_id: { value: e.value, label: e.label }, 
                                                        code_category: e.code || "ไม่มี code"
                                                    });
                                                }}
                                                value={this.state.category_id}
                                                isClearable
                                            ></Select>
                                            <input
                                                className="form-control"
                                                style={{marginTop: 20}}
                                                type="text"
                                                placeholder=""
                                                value={this.state.code_category}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-6 mb-2">
                                            <label className="mb-2">Serial Number:</label>
                                            <div>
                                                <Switch
                                                    id="serialNumberSwitch"
                                                    onChange={(checked) => this.setState({ serial_number: checked })}
                                                    checked={this.state.serial_number}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 mb-2">
                                            <label className="mb-2">หน่วยนับ:</label>
                                            <Select
                                                className="form-control select-search"
                                                styles={select_style}
                                                options={this.state.data_unit}
                                                onChange={(e) => {
                                                    this.setState({ unit_name: e });
                                                }}
                                                value={this.state.unit_name}
                                                isClearable
                                            />
                                        </div>
                                        <div className="col-6 mb-2">
                                            <label className="mb-2">ราคาขาย:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => {
                                                    if (!float(e.target.value)) {
                                                        return
                                                    }
                                                    this.setState({ sell_price: e.target.value })
                                                }}
                                                value={this.state.sell_price}
                                            />
                                        </div>
                                        <div className="col-6 mb-2">
                                            <label className="mb-2">ราคาต้นทุน:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => {
                                                    if (!float(e.target.value)) {
                                                        return
                                                    }
                                                    this.setState({ cost_price: e.target.value })
                                                }}
                                                value={this.state.cost_price}
                                            />
                                        </div>
                                        <div className="col-12 mb-2">
                                            <label className="mb-2">รายละเอียด:</label>
                                            <textarea
                                                className="form-control"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ product_detail: e.target.value }) }}
                                                value={this.state.product_detail}
                                                rows={5}
                                            />
                                        </div>
                                        <div className="col-6 ms-auto">
                                            <div className="w-100 d-flex">
                                                <div className="w-50 pe-1">
                                                    <button className="btn btn-outline-orange w-100" onClick={() => {
                                                        window.location.href = "/master/list-spare-parts-repair"
                                                    }}>
                                                        ยกเลิก
                                                    </button>
                                                </div>
                                                <div className="w-50 ps-1">
                                                    <button className="btn btn-orange w-100" onClick={() => {
                                                        if (this.state.product_id) {
                                                            this.UpdateProduct();
                                                        } else {
                                                            this.CreateProduct();
                                                        }
                                                    }}>
                                                        {this.state.product_id ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.product_type === "การซ่อม" && (
                        <div className="row">
                            <div className="col-12 col-md-8 col-lg-6 mx-auto p-3">
                                {/* หัวข้อ และ ปุ่มเพิ่ม */}
                                <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                                    <h3 className="mb-2"><b>{this.state.product_id ? "แก้ไขการซ่อม" : "เพิ่มการซ่อม"}</b></h3>
                                    <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master/list-spare-parts-repair" }}>
                                        <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                    </button>
                                </div>
                                <div className="w-100 card border-0 p-3 rounded-lg">
                                    <div className="row">
                                        <div className="col-12 mb-2">
                                            <label className="mb-2">รหัสการซ่อม:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ product_code: e.target.value }) }}
                                                value={this.state.product_code}
                                                readOnly
                                            />
                                        </div>
                                        <div className="col-12 mb-2">
                                            <label className="mb-2">ชื่องานซ่อม:</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ product_name: e.target.value }) }}
                                                value={this.state.product_name}
                                            />
                                        </div>
                                        <div className="col-12 mb-2">
                                            <label className="mb-2">รายละเอียดการซ่อม:</label>
                                            <textarea
                                                className="form-control"
                                                placeholder=""
                                                onChange={(e) => { this.setState({ product_detail: e.target.value }) }}
                                                value={this.state.product_detail}
                                                rows={5}
                                            />
                                        </div>
                                        <div className="col-6 ms-auto">
                                            <div className="w-100 d-flex">
                                                <div className="w-50 pe-1">
                                                    <button className="btn btn-outline-orange w-100" onClick={() => {
                                                        window.location.href = "/master/list-spare-parts-repair"
                                                    }}>
                                                        ยกเลิก
                                                    </button>
                                                </div>
                                                <div className="w-50 ps-1">
                                                    <button className="btn btn-orange w-100" onClick={() => {
                                                        if (this.state.product_id) {
                                                            this.UpdateProduct();
                                                        } else {
                                                            this.CreateProduct();
                                                        }
                                                    }}>
                                                        {this.state.product_id ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div >
        )
    }
}
